import loader from '@Foundation/loader/loader.vue';
import ProductRecommender from '@Feature/ProductRecommender';
import gsq from '@Project/CN/code/scripts/directives/index';

const components = {
  ...ProductRecommender.components,
  loader,
};

const directives = {
  ...gsq.directives,
};

const APACCustomizations = {
  install(localVue) {
    Object.entries(directives).map(([name, directive]) => localVue.directive(name, directive));
    Object.entries(components).map(([name, component]) => localVue.component(name, component));
  },
};

/**
 * Expose plugin name on `window` to enable manual installation — master driven
 */
if (typeof window !== 'undefined') {
  window.LOCAL_ZONE_PLUGIN_NAME = process.env.VUE_APP_LOCAL_ZONE_PLUGIN_NAME;
}

export default APACCustomizations;
